import VehicleRedirector, {
  getServerData
} from '../../../../cars/used/[brand]/[model]/[registration]'

export default VehicleRedirector

export { getServerData }
